import Swiper from 'swiper';
import { Keyboard, A11y, Pagination, Navigation, EffectFade, Autoplay } from "swiper/modules";
import { shouldAutoplay } from '../utils/functions';

export default function initHeroSlider() {
  const swiper = new Swiper('.js-hero-slider', {
    modules: [Keyboard, A11y, Pagination, Autoplay, EffectFade, Navigation],
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    allowTouchMove: false,
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      notificationClass: 'swiper-notification visually-hidden'
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: shouldAutoplay() ? {
        delay: 5000,
        disableOnInteraction: false,
      } : false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    }
  });
}